import { del, get, post, put } from "./api_helper"
import * as url from "./url_helper"

const getList = (endpoint: string, nextPage?: string, params?: object) =>
  get(nextPage || endpoint, params ? { params } : {});

// Login Method
const postJwtLogin = (data: any) => post(url.POST_JWT_LOGIN, data);
// Profile
export const getProfile = () => get(url.GET_PROFILE);
export const updateProfile = (data: any) => put(url.UPDATE_PROFILE, data);

//Domainchg
export const getDomainchgKeitaros = () => get(`${url.GET_DOMAINCHG}/keitaros`);
export const getDomainchgCampaigns = (id:number) => get(`${url.GET_DOMAINCHG}/${id}/campaigns`);
export const setDomainChange = (data: any) => post(`${url.GET_DOMAINCHG}/chgdomain`, data);

//JIRA
export const getProjects = () => post(url.GET_JIRA_PROJECTS, {});
export const getJiraUsers = () => post(url.GET_JIRA_USERS, {});
export const getJiraStatistics = (data: any) => post(url.GET_JIRA_STATISTICS, data);

//TRAFFIC ORDERS
export const fetchTrafficOrdersNotActive = (next_page: string, filter: object) =>
  getList(url.GET_TRAFFIC_ORDERS_NOT_ACTIVE, next_page, filter);

// Team Method
export const getTeam = (id: number) => get(`${url.GET_TEAMS}/${id}`);
export const getTeams = (next_page: string, filter: object) =>
  getList(url.GET_TEAMS, next_page, filter);
export const postTeam = (data: any) => post(url.GET_TEAMS, data);
export const updateTeam = (data: any, id: number) => put(`${url.GET_TEAMS}/${id}`, data);
export const delTeam = (id: number) => del(`${url.GET_TEAMS}/${id}`);
// User Method
export const getUser = (id: number) => get(`${url.GET_USERS}/${id}`);
export const getUsers = (next_page: string, filter: object) =>
  getList(url.GET_USERS, next_page, filter);
export const postUser = (data: any) => post(url.GET_USERS, data);
export const updateUser = (data: any, id: number) => put(`${url.GET_USERS}/${id}`, data);
export const delUser = (id: number) => del(`${url.GET_USERS}/${id}`);
// Broker Method
export const getBroker = (id: number) => get(`${url.GET_BROKERS}/${id}`);
export const getBrokers = (next_page: string, filter: object) =>
  getList(url.GET_BROKERS, next_page, filter);
export const postBroker = (data: any) => post(url.GET_BROKERS, data);
export const updateBroker = (data: any, id: number) => put(`${url.GET_BROKERS}/${id}`, data);
export const delBroker = (id: number) => del(`${url.GET_BROKERS}/${id}`);
export const getBrokersId =() => get(`${url.GET_BROKERS}/all`);
export const getCountries = () => get(url.GET_COUNTRIES);
// Offices Method
export const getOffices = (next_page: string, filter: object) =>
  getList(url.GET_OFFICES, next_page, filter);
export const postOffice = (data: any) => post(url.GET_OFFICES, data);

// Crm Systems Method
export const getCrmSystem = (id: number) => get(`${url.GET_CRM_SYSTEM}/${id}`);
export const getCrmSystems = (next_page: string, filter: object) =>
  getList(url.GET_CRM_SYSTEM, next_page, filter);
export const postCrmSystem = (data: any) => post(url.GET_CRM_SYSTEM, data);
export const updateCrmSystem = (data: any, id: number) => put(`${url.GET_CRM_SYSTEM}/${id}`, data);
export const deleteCrmSystem = (id: number) => del(`${url.GET_CRM_SYSTEM}/${id}`);

// Spends Method
export const getSpend = (id: number) => get(`${url.GET_SPENDS}/${id}`);
export const getSpends = (next_page: string, filter: object) =>
  getList(url.GET_SPENDS, next_page, filter);
export const postSpend = (data: any) => post(url.GET_SPENDS, data);
export const updateSpend = (data: any, id: number) => put(`${url.GET_SPENDS}/${id}`, data);
export const delSpend = (id: number) => del(`${url.GET_SPENDS}/${id}`);

// PriceDay Method
export const getPriceDay =(id: number) => get(`${url.GET_PRICE_DAY}/${id}`);
export const getPricesDay =(next_page: string, filter: object) =>
  getList(url.GET_PRICE_DAY, next_page, filter);
export const postPriceDay = (data: any) => post(url.GET_PRICE_DAY, data);
export const updatePriceDay = (data: any, id: number) => put(`${url.GET_PRICE_DAY}/${id}`, data);
export const delPriceDay = (id: number) => del(`${url.GET_PRICE_DAY}/${id}`);

// chekin page
export const postCheckinUser = (data: any) => post(url.POST_ADD_USER_CHEKIN, data);
export const getCheckin = (filter: any) => get(`${url.GET_CHECKIN}`, { params: filter });
export const getPermissions = () => get(url.GET_PERMISSIONS)
export const getPermission = (id: number) => get(`${url.GET_PERMISSIONS}/${id}`)
export const postPermission = (data: any) => post(url.GET_PERMISSIONS, data)
export const updatePermission = (data: any, id: number) => put(`${url.GET_PERMISSIONS}/${id}`, data)
export const delPermission = (id: number) => del(`${url.GET_PERMISSIONS}/${id}`)

export const getRoles = () => get(url.GET_ROLES)
export const getRole = (id: number) => get(`${url.GET_ROLES}/${id}`)
export const postRole = (data: any) => post(url.GET_ROLES, data)
export const updateRole = (data: any, id: number) => put(`${url.GET_ROLES}/${id}`, data)
export const delRole = (id: number) => del(`${url.GET_ROLES}/${id}`)


// dashboard
export const getStatistic = (filter: any) => get(`${url.GET_STATISTIC}`, {params: filter})
export const getTeamsAll = () => get(url.GET_TEAMS_ALL)
export const getUsersAll = () => get(url.GET_USERS_ALL)

// orders
export const getOrders = (next_page: string, filter: object) =>
  getList(url.GET_ORDERS, next_page, filter);
export const getOrder = (id: number) => get(`${url.GET_ORDERS}/${id}`)
export const getOrdersByTeam = (id: number) => get(`${url.GET_ORDERS}/team/${id}`)
export const postOrders = (data: any) => post(url.GET_ORDERS, data)
export const updateOrders = (data: any, id: number) => put(`${url.GET_ORDERS}/${id}`, data)
export const delOrders = (id: number) => del(`${url.GET_ORDERS}/${id}`)
// members
export const getTeamMembers = (id: number) => get(`${url.GET_TEAM_MEMBERS}${id}/users`)

// Tracker 
export const getTrackerData = () => get(`${url.GET_TRACKER}`)
export const postCapa = (data: any) => post(url.POST_CAPA, data)
export const getUpdateBrokerName = () => get(`${url.GET_UPDATE_BROKER_NAME}`)

export const getCheckers = () => get(url.GET_CHECKER)
export const getCheckersAll = () => get(url.GET_CHECKER_ALL)
export const getChecker = (id: number) => get(`${url.GET_CHECKER}/${id}`)


export const getCheckerStat = (id: number) => get(`${url.GET_CHECKER}/stat/${id}`)
export const postChecker = (data: any) => post(url.GET_CHECKER, data)
export const updateChecker = (data: any, id: number) => put(`${url.GET_CHECKER}/${id}`, data)

export const delChecker = (id: number) => del(`${url.GET_CHECKER}/${id}`)

export const getKeitaro = () => get(`${url.GET_KEITAROS}`)
export const getLandsoffers = (id: number) => get(`uni/${id}/getlandsofferslist`)
export const postKeitaros = (data: any) => post(url.POST_UNI_KEITAROS, data)

// leads Component
export const  getKeitaroDate =(data: any) => get(`${url.GET_KEITARO_DATA}?start_date=${data.from}&end_date=${data.to}`)
export const  postLeads =(data: any) => post(url.POST_OFFER_LEADS, data)

// Tickets
export const getTickets = (next_page: string, filter: object) =>
  getList(url.GET_TICKETS, next_page, filter);
export const getTicket = (uuid: string | number) => get(`${url.GET_TICKETS}/${uuid}`);
export const postTicket = (data: any) => post(url.GET_TICKETS, data);
export const updateTicket = (data: any, uuid: string | number) => put(`${url.GET_TICKETS}/${uuid}`, data);
export const deleteTicket = (uuid: string | number, confirmation: string) =>
  del(`${url.GET_TICKETS}/${uuid}`, {
    data: {
      confirmation,
    },
  });
export const acceptTicket = (uuid: string | number) => post(`${url.GET_TICKETS}/${uuid}/accept`, {});
export const getTicketMessages = (ticketUuid: string | number, next_page: string, filter: object) =>
  getList(`${url.GET_TICKETS}/${ticketUuid}/messages`, next_page, filter);
export const postTicketMessagesRead = (ticketUuid: string | number, data?: { last_read_message_id?: number }) =>
  post(`${url.GET_TICKETS}/${ticketUuid}/messages/read`, data || {});
export const getTicketActivity = (ticketUuid: string | number, next_page: string, filter: object) =>
  getList(`${url.GET_TICKETS}/${ticketUuid}/activity`, next_page, filter);
export const postTicketMessage = (ticketUuid: string | number, data: FormData) =>
  post(`${url.GET_TICKETS}/${ticketUuid}/messages`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// Ticket categories
export const getTicketCategories = () => get("/ticket-categories");

// Ticket canned responses
export const getTicketCannedResponses = (filter?: object) =>
  get("/ticket-canned-responses", { params: filter });
export const postTicketCannedResponse = (data: {
  title: string;
  body: string;
  category_id?: number | null;
  is_shared?: boolean;
}) => post("/ticket-canned-responses", data);
export const updateTicketCannedResponse = (responseId: number, data: {
  title?: string;
  body?: string;
  category_id?: number | null;
  is_shared?: boolean;
}) => put(`/ticket-canned-responses/${responseId}`, data);
export const deleteTicketCannedResponse = (responseId: number) =>
  del(`/ticket-canned-responses/${responseId}`);
export const postUseTicketCannedResponse = (responseId: number) =>
  post(`/ticket-canned-responses/${responseId}/use`, {});

// Ticket satisfaction rating
export const postTicketRating = (ticketUuid: string | number, data: { rating: number; comment?: string }) =>
  post(`${url.GET_TICKETS}/${ticketUuid}/rate`, data);

// Ticket tags
export const getTicketTags = () => get("/ticket-tags");
export const syncTicketTags = (ticketUuid: string | number, tagIds: number[]) =>
  post(`${url.GET_TICKETS}/${ticketUuid}/tags`, { tag_ids: tagIds });

// Ticket reassign
export const postTicketAssign = (ticketUuid: string | number, userId: number) =>
  post(`${url.GET_TICKETS}/${ticketUuid}/assign`, { user_id: userId });

// Ticket bulk actions
export const postTicketBulkAction = (data: { ticket_ids: number[]; action: string; value?: any }) =>
  post(`${url.GET_TICKETS}/bulk`, data);

// Ticket CSV export — returns blob
export const downloadTicketCsv = (params?: Record<string, string>) =>
  get(`${url.GET_TICKETS}/export`, { params, responseType: 'blob' });

// Ticket stats/analytics
export const getTicketStats = (params?: object) =>
  get(`${url.GET_TICKETS}/stats`, { params });

// Ticket watchers
export const postTicketWatch = (ticketUuid: string | number) =>
  post(`${url.GET_TICKETS}/${ticketUuid}/watch`, {});
export const deleteTicketWatch = (ticketUuid: string | number) =>
  del(`${url.GET_TICKETS}/${ticketUuid}/watch`);

// Ticket relations
export const getTicketRelations = (ticketUuid: string | number) =>
  get(`${url.GET_TICKETS}/${ticketUuid}/relations`);
export const postTicketRelation = (ticketUuid: string | number, data: { related_ticket_id: number; relation_type: string }) =>
  post(`${url.GET_TICKETS}/${ticketUuid}/relations`, data);
export const deleteTicketRelation = (ticketUuid: string | number, relationId: number) =>
  del(`${url.GET_TICKETS}/${ticketUuid}/relations/${relationId}`);


// Ticket notification preferences
export const getTicketNotificationPreferences = () =>
  get("/ticket-notification-preferences");
export const updateTicketNotificationPreferences = (data: any) =>
  put("/ticket-notification-preferences", data);

export {
  postJwtLogin,
}
